var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionSoftware2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1669_2932",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "722d942177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H80V80H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1669_2932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.0165 14.0165C54.0165 21.7586 40 40 40 40C40 40 25.9835 21.7586 25.9835 14.0165C25.9835 6.27145 32.2549 0 40 0C47.7451 0 54.0165 6.27145 54.0165 14.0165ZM80 40C80 32.2549 73.7286 25.9835 65.9835 25.9835C58.2414 25.9835 40 40 40 40C40 40 58.2414 54.0165 65.9835 54.0165C73.7286 54.0165 80 47.742 80 40ZM40 80C47.7451 80 54.0165 73.7286 54.0165 65.9835C54.0165 58.2384 40 40 40 40C40 40 25.9835 58.2384 25.9835 65.9835C25.9835 73.7286 32.2549 80 40 80ZM0 40C0 47.742 6.27145 54.0165 14.0165 54.0165C21.7616 54.0165 40 40 40 40C40 40 21.7616 25.9835 14.0165 25.9835C6.27145 25.9835 0 32.2549 0 40Z",
    fill: "#D7D3F7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionSoftware2);
export default __webpack_public_path__ + "static/media/icon-section-software-2.b7b2ff82fe3ecc13368ac59acec01e08b9eddf86fca1f871665494096e644b8f.svg";
export { ForwardRef as ReactComponent };